import { useEffect, useState } from "react";
import Log0 from './Log0';
import Log1 from './Log1';
import Log2 from './Log2';
import { useApp } from "../../hooks/AppProvider";
import '../../css/login.css';


function Login() {
    let app = useApp();

    let [state, setState] = useState(0);
    let [username, setUsername] = useState("");
    let [password, setPassword] = useState("");
    let [cPassword, setCPassword] = useState("");
    let [statusMessage, setStatusMessage] = useState("");

    useEffect(() => {
        setStatusMessage("");
    }, [state, username, password])

    useEffect(() => {
        setPassword("");
        setCPassword("");
    }, [username]);

    useEffect(() => {
        if(state == -1 || app.isLogin())
            app.navigate('/', { replace: true });
    }, [state]);

    return (
        <>
        <div className="login-container">
            <img src="/img/profile.png" alt="Icone de profile" className="login-profile" />
            <div className="login-message">
                <h2>Connexion</h2>
                <span className="error-text">{statusMessage}</span>
            </div>
            <div className="login-form">
                {state === 0 && <Log0 setStatusMessage={setStatusMessage} statusMessage={statusMessage} setState={setState} username={username} setUsername={setUsername}></Log0>}
                {state === 1 && <Log1 setStatusMessage={setStatusMessage} statusMessage={statusMessage} setState={setState} username={username} setUsername={setUsername} password={password} setPassword={setPassword}></Log1>}
                {state === 2 && <Log2 setStatusMessage={setStatusMessage} statusMessage={statusMessage} setState={setState} username={username} setUsername={setUsername} password={password} setPassword={setPassword} cPassword={cPassword} setCPassword={setCPassword}></Log2>}
            </div>
        </div> 
        </>
    );
}

export default Login;